import styled from "@emotion/styled";
import ApexCharts from "react-apexcharts";
import { machineProductionUtilizationChartData } from "./idleTimeMockupData";

interface WorkTimeChartProps {
  selectedMonth: string; // "2024-06"
  selectedMachines: string[];
}

export const IdleTimeChart = ({ selectedMonth, selectedMachines }: WorkTimeChartProps) => {
  const getDateLabelsForMonth = (monthStr: string) => {
    const [year, month] = monthStr.split("-").map(Number);
    const daysInMonth = new Date(year, month, 0).getDate(); // month는 1-based
    return Array.from(
      { length: daysInMonth },
      (_, i) => `${String(month).padStart(2, "0")}-${String(i + 1).padStart(2, "0")}`,
    );
  };

  const dateLabels = getDateLabelsForMonth(selectedMonth);

  const series = [
    {
      name: "생산량 (Bar)",
      type: "bar",
      data: selectedMachines.map(
        (name) => machineProductionUtilizationChartData[name]?.production ?? [],
      ),
    },
    {
      name: "가동률 (Line)",
      type: "line",
      data: selectedMachines.map(
        (name) => machineProductionUtilizationChartData[name]?.utilization ?? [],
      ),
    },
  ].flatMap((seriesSet, i) =>
    selectedMachines.map((machineName, idx) => ({
      name: `${machineName} - ${seriesSet.name}`,
      type: seriesSet.type,
      data:
        machineProductionUtilizationChartData[machineName]?.[
          seriesSet.name === "생산량 (Bar)" ? "production" : "utilization"
        ] ?? new Array(dateLabels.length).fill(0),
    })),
  );

  const options = {
    chart: { height: 350, type: "line" as const, stacked: false },
    dataLabels: { enabled: false },
    stroke: { width: [2, 2] },
    xaxis: {
      categories: dateLabels,
    },
    yaxis: [
      {
        axisTicks: { show: true },
        axisBorder: { show: true, color: "#008FFB" },
        labels: { style: { colors: "#008FFB" } },
        title: { text: "생산량", style: { color: "#008FFB" } },
      },
      {
        opposite: true,
        axisTicks: { show: true },
        axisBorder: { show: true, color: "#00E396" },
        labels: { style: { colors: "#00E396" } },
        title: { text: "가동률 (%)", style: { color: "#00E396" } },
      },
    ],
  };

  return (
    <Container>
      {series.length > 0 ? (
        <ApexCharts options={options} series={series} type="line" height={350} />
      ) : (
        <div style={{ textAlign: "center", color: "#888", padding: "2rem" }}>
          기계를 선택하면 차트가 표시됩니다.
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;
